module.exports = __webpack_public_path__ + "static/take-it-easy-logo-3c9f99bdad31b27038bbc5f2ba8ca8e2.png";